import React from "react";
import { SzIcon, SzTypographie } from "@suezenv/react-theme-components";
import { useTranslation } from "react-i18next";
import { GetOneControlPoint } from "../../../../services/types/control-point";
import { useHistory } from "react-router-dom";

interface Props {
  controlPoint: GetOneControlPoint;
}

const Header: React.FC<Props> = ({ controlPoint }) => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <div className="row mb-3 justify-content-between">
      <div className="col-auto">
        <div className="row">
          <div className="col-auto pr-0">
            <SzIcon variant="line" icon="pencil-write" />
          </div>
          <div className="col-auto pl-1">
            <SzTypographie variant="body" weight="medium" className="mb-0">
              {t("controlPoint:editPage.title")}
            </SzTypographie>
            <SzTypographie variant="caption" weight="light" className="mb-0">
              {t("controlPoint:editPage.subTitle")}
            </SzTypographie>
          </div>
        </div>
      </div>

      <div className="col-auto align-self-end">
        <SzIcon
          variant="line"
          icon="remove"
          onClick={() => {
            const url = `/pdc/view/${controlPoint.id}`;
            history.push(url);
          }}
        />
      </div>
    </div>
  );
};

export default Header;
